import { RoutePath, type RoutePaths } from "@/lib/routes"
import { agreementRoutesPaths } from "./agreement"
import { billsAndPaymentsRoutesPaths } from "./billsAndPayments"
import { DASHBOARD_ROOT_URL } from "./constants/dashboardRootUrl"
import { ecoSessionRoutesPaths } from "./ecoSession"
import { personalDetailsRoutesPaths } from "./personalDetails"
import { potRoutesPaths } from "./pot"
import { propertyRoutesPaths } from "./property"

export const dashboardRoutesPaths = {
    root: RoutePath.create(`/${DASHBOARD_ROOT_URL}`),
    accounts: RoutePath.create(`/${DASHBOARD_ROOT_URL}/comptes`),
    ...personalDetailsRoutesPaths,
    ...potRoutesPaths,
    ...propertyRoutesPaths,
    ...billsAndPaymentsRoutesPaths,
    ...agreementRoutesPaths,
    consumption: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/suivi-conso`
    ),
    consumptionElectricity: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/suivi-conso/electricite/:supplyPointId`
    ),
    consumptionGas: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/suivi-conso/gaz/:supplyPointId`
    ),
    ...ecoSessionRoutesPaths,
    selfReadings: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/compteurs/:meterPointId/auto-releve`
    ),
    referral: RoutePath.create(`/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/parrainage`),
    wheelOfFortune: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/roue-de-la-fortune`
    ),
    fanClub: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/fan-club`
    ),
} as const satisfies RoutePaths

export const dashboardRoutesPathsList = Object.values(dashboardRoutesPaths)
